// extracted by mini-css-extract-plugin
export default {"card":"content-page_card__1bkFp typography_bodyFont__1UNdB","section":"content-page_section__2weHW","heading":"content-page_heading__dydlV"};